import type { Profile } from '@/engine/types';
import type { FoodRow } from '@/lib/db';
import { keyWords } from '@/lib/search';

/** "Marisco, frutos secos , " → ['marisco', 'frutos secos']. */
export function parseList(text: string): string[] {
  return text
    .split(',')
    .map((item) => item.trim().toLowerCase())
    .filter(Boolean);
}

/** Lo que excluye ser vegetariano. */
const MEAT_TAGS = ['carne', 'cerdo', 'pescado', 'marisco'];

type Preferences = Pick<Profile, 'vegetarian' | 'allergies' | 'dislikes'>;

/**
 * ¿Choca este alimento con las alergias o gustos de la persona? (SPEC 7.1.3)
 *
 * Se compara lo que ella escribe («frutos secos», «lácteos», «gambas») con el
 * nombre, los sinónimos y las familias del alimento, todo en palabras
 * normalizadas y sin plural. Antes se comparaba el texto tal cual con la
 * etiqueta interna y «frutos secos» nunca casaba con `fruto_seco`. Un término
 * de varias palabras exige todas, para que «leche de coco» no quite la leche.
 */
export function excludedByPreferences(food: FoodRow, prefs: Preferences): boolean {
  if (prefs.vegetarian && food.tags.some((tag) => MEAT_TAGS.includes(tag))) return true;

  const terms = [...prefs.allergies, ...prefs.dislikes];
  if (terms.length === 0) return false;

  const known = new Set([
    ...keyWords(food.name),
    ...food.synonyms.flatMap(keyWords),
    ...food.tags.flatMap((tag) => keyWords(tag.replace(/_/g, ' '))),
  ]);
  return terms.some((term) => {
    const words = keyWords(term);
    return words.length > 0 && words.every((word) => known.has(word));
  });
}
